<template>
  <div>
    <div class="gameplay_bg">
      <div class="gameplay_bar"></div>
      <div class="container">
        <timer/>
        <game-header/>
        <component v-if="miniGames[currentMiniGameRound]" :is="swipoMiniGameMap['SWIPO_GAME'].miniGameComponent" :key="miniGames[currentMiniGameRound].id"/>
      </div>
      <game-footer/>
    </div>
    <component :is="componentModal" @startNewGame="startNewGameMethod" @close="showModal"/>
    <component :is="modalForHomePage"/>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapMutations, mapActions } from 'vuex';
import webSocket from '@/common/webSocket';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import SwipoGame from '@/components/home/game/SwipoGame';
import Timer from './Timer';
import GameFooter from './GameFooter';
import GameHeader from './GameHeader';
import PostGameSwipo from '../modals/postgame/PostGameSwipo';
import PreGameModal from '../modals/pregame/PreGameModal';
import GameMaintenance from '../modals/Maintenance';
import NewGameModalWithGameMode from '../modals/postgame/NewGameModalWithGameMode';
import ZeroBalance from '../modals/ZeroBalance';

export default {
  name: 'genericGameComponent',
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin2],
  components: {
    NewGameModalWithGameMode,
    GameMaintenance,
    PreGameModal,
    PostGameSwipo,
    GameHeader,
    GameFooter,
    Timer,
    SwipoGame,
  },
  data() {
    return {
      gameInfo: null,
      componentModal: null,
      pendingFinishedGame: false,
      swipoMiniGameMap: {
        SWIPO_GAME: {
          miniGameComponent: SwipoGame,
        },
      },
      miniGamesImages: [],
      stompClient: null,
      subscription: null,
    };
  },
  created() {
    console.log('in Game created hook');
    this.stompClient = webSocket.getGameStompClient();
    this.initQuestionData();
    this.startSubscriptionChannel();
    this.gameInfo = this.miniGames[this.currentMiniGameRound];
    console.log('GAMEINFOOOOO: ', this.gameInfo);
    for (let i = 0; i < this.miniGames.length; i += 1) {
      this.miniGamesImages[i] = this.miniGames[i].img;
      console.log('MINIGAME ID: ', this.miniGames[i].id);
      console.log('MINIGAME IMAGE: ', this.miniGames[i].img);
      console.log('MINIGAME IMAGE TABLE: ', this.miniGamesImages[i]);
    }
    this.setMiniGamesImagesForSwipe(this.miniGamesImages);
  },
  beforeDestroy() {
    console.log('in game\'s beforeDestroy hook');
    this.subscription.unsubscribe();
    this.resetGameState();
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('game', [
      'resetGameState',
      'setMiniGamesImagesForSwipe',
      'setGameInProgress',
    ]),
    stompFailure(error) {
      console.log(error);
      window.location.reload();
    },
    initQuestionData() {
      this.normalTransition = false;
    },
    startSubscriptionChannel() {
      console.info(`Subscribing to channel: /topic/finishedGame/${this.gameID}`);
      this.subscription = this.stompClient.subscribe(`/topic/finishedGame/${this.gameID}`, (response) => {
        // parse server response and return if any errors occur
        const responseData = this.parseServerResponse(response.body);
        if (responseData === null || responseData === 'Maintenance') {
          this.componentModal = GameMaintenance;
          this.normalTransition = true;
          this.showModal();
        } else {
          this.storeSwipoPostGameData(this.parseServerResponse(response.body));
          this.normalTransition = true;
          if (this.answerInFlight) {
            this.pendingFinishedGame = true;
          } else {
            this.getUserLoginDetails().then(() => {
              this.componentModal = PostGameSwipo;
              this.showModal();
            });
          }
        }
      });
    },
    startNewGameMethod() {
      this.setGameInProgress(false);
      this.getUserLoginDetails().then(() => {
        if (this.userDetails.availableGames !== 0) {
          this.componentModal = PreGameModal;
          this.showModal();
        } else {
          console.log('NO AVAILABLE GAMES...');
          this.$router.push('/home');
          this.storeModalForHomePage(ZeroBalance);
          this.showHideModal();
        }
      });
    },
    showModal() {
      /* eslint-disable */
      const vm = this;
      this.$nextTick(() => {
        // open modal
        $('.modal,.modal-overlay,.overlay').fadeIn(200);
        $("body").addClass("modal-open");
        // show/hide modal
        $('.modal-close, .modal-overlay,.btn_close, .overlay, .x_close').click(function () {
          $(".popup_box").fadeOut(200);
          $(".overlay").fadeOut(200);
          $('.modal, .modal-overlay').fadeOut();
          $("body").removeClass("modal-open");
          vm.getUserLoginDetails().then(() => {
            vm.$router.push('home');
          });
        });
      });
      /* eslint-enable */
    },
  },
  watch: {
    answerInFlight(val) {
      if (!val && this.pendingFinishedGame) {
        this.pendingFinishedGame = false;
        this.getUserLoginDetails().then(() => {
          this.componentModal = PostGameSwipo;
          this.showModal();
        });
      }
    },
  },
  computed: {
    ...mapState('game', [
      'gameID',
      'miniGameType',
      'gameType',
      'gameMode',
      'miniGames',
      'currentMiniGameRound',
      'answerInFlight',
    ]),
    ...mapState('common', [
      'modalForHomePage',
      'userDetails',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/Game.vue